import SagahHeader from '@/components/header/'
import SagahFooter from '@/components/footer/'
import NavigationDrawer from '@/components/navigation-drawer'
import ModalStructure from '@/components/modals/modal-structure'
import QueryResult from '@/components/query-result'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import { omit, isEqual, uniqWith } from 'lodash'

export default {
  components: {
    SagahHeader,
    SagahFooter,
    NavigationDrawer,
    ModalStructure,
    QueryResult
  },
  data () {
    return {
      queryStructure: {
        selectedDatabase: {},
        description: '',
        query: '',
        queryFields: [],
        paramsSqlExplanation: []
      },
      informationsModal: {
        isOpenModal: false,
        title: '',
        message: '',
        textConfirm: '',
        textCancel: '',
        isConfirmButtonLoading: false,
        emitConfirm: false
      },
      isLoadingDatabase: false,
      isLoadingSaveQuery: false,
      isLoadingUpdateQuery: false,
      isLoadingExecuteQuery: false
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedQuery',
      'getterAccount',
      'getterDatabases'
    ])
  },
  mounted () {
    this.getDatabases()

    this.clearQueryStructure()
  },
  methods: {
    ...mapActions([
      'actionGetDatabases',
      'actionSaveQuery',
      'actionDeleteQuery',
      'actionPutQuery',
      'actionExecuteQuery'
    ]),
    ...mapMutations([
      'SET_SELECTED_QUERY',
      'CLEAN_RESULT_QUERY'
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    }),
    getDatabases () {
      this.isLoadingDatabase = true

      this.actionGetDatabases()
        .then(() => {
          this.isLoadingDatabase = false
        }).catch((err) => {
          this.isLoadingDatabase = false

          this.addToast({
            text: err.message || err,
            type: 'danger'
          })
        })
    },
    textManagementQuery () {
      if (this.getterAccount.role === 'administrator') {
        return this.queryStructure.id ? 'Editar Query' : 'Inserir Query'
      } else {
        return 'Query selecionada:'
      }
    },
    queryChanged (text) {
      if (text) {
        var arrayStringArroundAt = text.split('@@')
          .filter((element, index, array) => {
            return (index % 2 === 1)
          })
          .map(stringArroundAt => {
            const queryField = this.queryStructure && this.queryStructure.queryFields &&
              this.queryStructure.queryFields.find(query => query.name === stringArroundAt)
            const description = (queryField && queryField.description) || ''
            const value = (queryField && queryField.value) || ''
            return {
              name: stringArroundAt,
              description,
              value
            }
          })
        this.queryStructure.queryFields = uniqWith(arrayStringArroundAt, isEqual)
      }
    },
    saveQuery () {
      const params = {
        database: this.queryStructure.selectedDatabase,
        description: this.queryStructure.description,
        query: this.queryStructure.query,
        valueFields: [],
        paramsSqlExplanation: this.queryStructure.queryFields.map((field) => field.description)
      }

      this.isLoadingSaveQuery = true

      this.actionSaveQuery(params)
        .then(() => {
          this.addToast({
            text: 'Query salva com sucesso',
            type: 'success'
          })

          this.clearQueryStructure()

          this.isLoadingSaveQuery = false
        })
        .catch((err) => {
          this.addToast({
            text: err.message || err,
            type: 'danger'
          })

          this.isLoadingSaveQuery = false
        })
    },
    clearQueryStructure () {
      this.queryStructure = {
        selectedDatabase: {},
        description: '',
        query: '',
        queryFields: [],
        paramsSqlExplanation: []
      }

      this.SET_SELECTED_QUERY('')

      this.CLEAN_RESULT_QUERY()
    },
    setSelectedQuery (query) {
      this.queryStructure = query

      this.queryChanged(this.queryStructure.query)

      this.queryStructure.queryFields.map((field, index) => {
        field.description = query.paramsSqlExplanation[index]
      })

      const database = this.queryStructure.database

      this.queryStructure.selectedDatabase = database

      this.queryStructure = omit(this.queryStructure, 'database')

      this.SET_SELECTED_QUERY(this.queryStructure)

      this.CLEAN_RESULT_QUERY()
    },
    deleteQuery () {
      this.informationsModal = {
        isOpenModal: true,
        title: 'Excluir Query',
        message: `<span> Deseja realmente excluir esta query? <b>${this.getterSelectedQuery.description}</b> </span>`,
        isConfirmButtonLoading: false,
        emitConfirm: this.confirmDeleteQuery
      }
    },
    confirmDeleteQuery () {
      this.informationsModal.isConfirmButtonLoading = true

      this.actionDeleteQuery(this.getterSelectedQuery.id)
        .then(() => {
          this.addToast({
            text: 'Query excluída com sucesso.',
            type: 'success'
          })

          this.informationsModal.isConfirmButtonLoading = false
          this.informationsModal.isOpenModal = false
          this.clearQueryStructure()
        }).catch((err) => {
          this.addToast({
            text: err.message || err,
            type: 'danger'
          })

          this.informationsModal.isConfirmButtonLoading = false
        })
    },
    updateQuery () {
      const params = {
        id: this.getterSelectedQuery.id,
        body: {
          database: this.queryStructure.selectedDatabase,
          description: this.queryStructure.description,
          query: this.queryStructure.query,
          valueFields: [],
          paramsSqlExplanation: this.queryStructure.queryFields.map((field) => field.description)
        }
      }

      this.isLoadingUpdateQuery = true

      this.actionPutQuery(params)
        .then(() => {
          this.isLoadingUpdateQuery = false
          this.clearQueryStructure()
        }).catch((err) => {
          this.addToast({
            text: err.message || err,
            type: 'danger'
          })

          this.isLoadingUpdateQuery = false
        })
    },
    executeQuery () {
      const params = {
        database: {
          id: this.queryStructure.selectedDatabase.id
        },
        query: this.queryStructure.query,
        valueFields: this.queryStructure.queryFields.map((field) => ({ [field.name]: field.value }))
      }

      this.isLoadingExecuteQuery = true

      this.actionExecuteQuery(params)
        .then((result) => {
          this.isLoadingExecuteQuery = false

          this.scrollTo()
        }).catch(() => {
          this.addToast({
            text: 'Houve um erro ao executar a query.',
            type: 'danger'
          })

          this.scrollTo()

          this.isLoadingExecuteQuery = false
        })
    },
    scrollTo () {
      const element = document.getElementsByClassName('query-content')[0]

      element.scrollIntoView({ behavior: 'smooth' })
    },
    verifyIsValue () {
      if (this.queryStructure.queryFields.length > 0) {
        const verifyIsEmptyValue = this.queryStructure.queryFields.map((item) => {
          if (!item.value) {
            return true
          } else {
            return false
          }
        })

        return verifyIsEmptyValue.includes(true)
      } else {
        return true
      }
    }
  }
}
